import { Copy, Download } from "lucide-react";

export default function BatchPasswordGenerator({
    numPasswords,
    setNumPasswords,
    batchPasswords,
    copyPassword,
    generateBatch,
}) {
    // Download as CSV with header and timestamp
    const downloadCSV = () => {
        if (!batchPasswords.length) return;

        const csvHeader = "Password,Generated At\n";
        const csvRows = batchPasswords
            .map(
                (p) =>
                    `"${p}","${new Date().toLocaleString("en-GB", {
                        hour12: false,
                    })}"`
            )
            .join("\n");

        const csvContent = "data:text/csv;charset=utf-8," + csvHeader + csvRows;
        const encodedUri = encodeURI(csvContent);

        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "batch_passwords.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Handle input change with max limit
    const handleInputChange = (e) => {
        let value = Number(e.target.value);
        if (value > 100) value = 100;
        if (value < 1) value = 1;
        setNumPasswords(value);
    };

    return (
        <div className="bg-gray-50 p-6 rounded-2xl border shadow-sm space-y-4">
            


            <p className="text-gray-600 text-sm">
                Generate multiple passwords at once. Choose the number below (max 100) and click "Generate".
            </p>

            <div className="flex flex-wrap items-center gap-3">
                <label className="text-gray-700 font-medium">Number of Passwords:</label>
                <input
                    type="number"
                    min="1"
                    max="100"
                    value={numPasswords}
                    onChange={handleInputChange}
                    className="w-24 border border-gray-300 p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500"
                />
                <button
                    onClick={generateBatch}
                    className="bg-cyan-700 text-white px-4 py-2 rounded-lg hover:bg-cyan-600 transition"
                >
                    Generate
                </button>
            </div>

            {numPasswords > 0 && (
                <p className="text-gray-700 text-sm">
                    You are about to create <strong>{numPasswords}</strong> passwords.
                </p>
            )}

            {/* Download CSV Button */}
            {batchPasswords.length > 0 && (
                <div className="flex justify-end">
                    <button
                        onClick={downloadCSV}
                        className="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition"
                    >
                        <Download size={16} /> Download CSV
                    </button>
                </div>
            )}

            {/* Generated Passwords List */}
            {batchPasswords.length > 0 && (
                <div className="grid gap-2 max-h-64 overflow-y-auto">
                    {batchPasswords.map((p, i) => (
                        <div
                            key={i}
                            className="flex justify-between items-center p-2 bg-white border rounded-lg shadow-sm"
                        >
                            <span className="font-mono break-all text-gray-800">{p}</span>
                            <button
                                onClick={() => copyPassword(p)}
                                className="text-gray-500 hover:text-cyan-600 transition"
                            >
                                <Copy size={16} />
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
